import { useState, useCallback } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';


export const usePriceList = (commonParams) => {
  const [dataPriceList, setDataPriceList] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState(null);
  const [priceListCode, setPriceListCode] = useState(null);

  const loadPriceList = useCallback(async () => {
    const para = {
      ...commonParams,
      masterGroup: 'SO_PRICE_LIST',
    };

    try {
      const result = await callApi(
        API_ENDPOINTS.GET_MASTER_LIST,
        'POST',
        { 'Content-Type': 'application/json' },
        para
      );

      if (result && result.length > 0) {
        // Add empty string at start if array and no empty item
        const updatedData =
          Array.isArray(result) && !result.includes('')
            ? [''].concat(result)
            : result;

        setDataPriceList(updatedData);

        // Set default selection if available
        if (updatedData.length > 1) {
          setSelectedPriceList(updatedData[1]);
          setPriceListCode(updatedData[1].CodeId);
        }
      } else {
        alert('Price List not found');
      }
    } catch (error) {
      alert(error.message);
    }
  }, [commonParams]);

  return {
    dataPriceList,
    selectedPriceList,
    priceListCode,
    setSelectedPriceList,
    loadPriceList,
  };
};
